// @flow
import { call, put } from 'redux-saga/effects';
import i18n from 'i18next';
import * as Sentry from '@sentry/react';
import { unvalidateLogin } from '../../actions/account/session';
import { dashboardReady, fetchUser, fetchUserInfos, newOrganization, updateUser } from '../../actions/account/user';
import { fetchAvaWebAppSession } from '../../actions/session';
import firebase from '../../firebase';
import { IOrganization } from '../../modules/account/models/organization';
import * as avaApi from '../../services/api/ava';
import { users } from '../../services/api/saas';
import { redirectTo } from '../../actions/session';

// $FlowFixMe
export function* login({ payload }: any) {
  yield put(fetchUser.request(payload.user));
}

// $FlowFixMe
export function* unvalidateLoginRequest() {
  yield firebase.auth().signOut();
}

// $FlowFixMe
export function* fetchUserRequest({ payload }: any) {
  try {
    const orgType = window.localStorage.getItem('account_orgType');

    const res = yield call(users.getOrCreateUser, {
      name: payload ? payload.name : '',
      type: orgType,
    });

    if (res.data.user && res.data.user.parse) {
      // This passes some data from the 'account' world to the 'web' world.
      // Ideally all the 'user' objects should be unified, but this requires a lot
      // of refactoring. This action in necessary to show the name of the user
      // in the sidebar.
      yield put({
        type: 'USER_UPDATE',
        user: res.data.user.parse,
      });
      yield put(fetchUser.success(res.data));
      yield put(fetchUserInfos.request());
      yield put(redirectTo({ pathname: '/account/dashboard' }));
    } else {
      yield put(unvalidateLogin());
      if (orgType === 'individual') {
        yield put(redirectTo({ pathname: '/account/login/individual' }));
      } else if (!orgType) {
        yield put(redirectTo({ pathname: '/account/start' }));
      }
    }
  } catch (err) {
    yield put(fetchUser.failure(err.response));
  }
}

// $FlowFixMe
export function* updateUserRequest({ payload }: any) {
  try {
    const { role } = payload;
    const { data } = yield call(users.getOrCreateUser);
    if (data.user && data.user.parse) {
      const { user } = data;
      yield call(avaApi.users.updateRole, {
        avaId: user.parse.avaId,
        firebaseAuthUID: user.parse.firebaseAuthUID,
        role,
      });
      yield put(fetchAvaWebAppSession({}));
      yield put(updateUser.success(data));
    }
    if (payload.reset) {
      yield window.open('/', '_self');
    }
  } catch (err) {
    Sentry.captureException(err);
    yield put(updateUser.failure(err.response));
  }
}

// $FlowFixMe
export function* fetchUserInfoRequest() {
  try {
    const { language } = i18n;

    const res = yield call(users.getUser, language);

    yield put(fetchUserInfos.success(res.data));
  } catch (err) {
    const { data } = err.response;

    if (
      data.ok === false &&
      data.error &&
      data.error.error &&
      data.error.error.content.missing &&
      data.error.error.content.missing.organization
    ) {
      const isIndividual = window.localStorage.getItem('account_orgType') === 'individual';
      if (isIndividual) {
        const organization: IOrganization = {
          name: '',
          type: 'individual',
        };
        yield put(newOrganization.request(organization));
      } else {
        yield put(redirectTo({ pathname: '/account/organization/create' }));
      }
    } else if (err && err.response && err.response.data.ok === false) {
      yield put(unvalidateLogin());
      yield put(redirectTo({ pathname: '/account/login' }));
    }
    yield put(fetchUserInfos.failure(err.response));
  }
}

// $FlowFixMe
export function* handleFetchInfoUser({ payload }: any) {
  if (!payload.selfLicence.licence && !payload.organization) {
    yield put(redirectTo({ pathname: '/account/organization/create' }));
  }
  yield put(dashboardReady());
}

// $FlowFixMe
export function* logout() {
  yield firebase.auth().signOut();
}

// $FlowFixMe
export function* updateLang() {
  // $FlowFixMe
  if (window?.location?.pathname?.includes('/buy')) {
    yield put(fetchUserInfos.request());
  }
}
